/* eslint-disable @typescript-eslint/no-explicit-any */
import { Pipe, PipeTransform } from '@angular/core';
/**
 * Apply a function to an input
 * from component template.
 * Provided function needs to be pure
 * for optimized performances
 */
@Pipe({
  name: 'useFunction',
  pure: true,
  standalone: true
})
export class UseFunctionPipe implements PipeTransform {
  transform<T>(
    input: any,
    formatFunction: ((...args: any[]) => T) | null | undefined,
    ...args: any[]
  ): T {
    if (!formatFunction) {
      return input;
    }
    return formatFunction(input, ...args);
  }
}
